<script setup>
import { computed, onMounted } from 'vue';
import { useObterTotalSolicitacoesCdiPorTipo } from '~/composables/compromissos/useObterTotalSolicitacoesCdiPorTipo';
import { colors } from '~/utils';

const {
  status: obterTotalSolicitacoesCdiPorTipoStatus,
  data: obterTotalSolicitacoesCdiPorTipoData,
  runAsync: obterTotalSolicitacoesCdiPorTipoAsync,
} = useObterTotalSolicitacoesCdiPorTipo();

const chartOptions = computed(() =>
{
  if (obterTotalSolicitacoesCdiPorTipoStatus.value !== 'success')
  {
    return null;
  }
  return {
    chart: {
      type: 'bar',
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
      animations: {
        enabled: false,
      },
    },
    colors,
    plotOptions: {
      bar: {
        distributed: true,
      },
    },
    series: [
      {
        name: 'total',
        data: obterTotalSolicitacoesCdiPorTipoData.value.items.map(
          x => x.total,
        ),
      },
    ],
    xaxis: {
      categories: obterTotalSolicitacoesCdiPorTipoData.value.items.map(
        x => x.servico,
      ),
      labels: {
        show: false,
      },
    },
  };
});

onMounted(async () =>
{
  await obterTotalSolicitacoesCdiPorTipoAsync();
});
</script>

<template>
  <ChartCard
    :status="obterTotalSolicitacoesCdiPorTipoStatus"
    :options="chartOptions"
  >
    <template #title>
      <span style="color: rgb(128 128 128); font-size: 16px">TOTAL DE SOLICITAÇÕES POR TIPO</span>
    </template>
  </ChartCard>
</template>
